__turbopack_context__.v({
  "activeTabFaq": "FaqWithoutCategory-module-scss-module__HQ-QOa__activeTabFaq",
  "answerCollapse": "FaqWithoutCategory-module-scss-module__HQ-QOa__answerCollapse",
  "answerCollapseInner": "FaqWithoutCategory-module-scss-module__HQ-QOa__answerCollapseInner",
  "answerOpen": "FaqWithoutCategory-module-scss-module__HQ-QOa__answerOpen",
  "backChange": "FaqWithoutCategory-module-scss-module__HQ-QOa__backChange",
  "deactiveTabFaq": "FaqWithoutCategory-module-scss-module__HQ-QOa__deactiveTabFaq",
  "faqAns": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqAns",
  "faqAnsCk": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqAnsCk",
  "faqItem": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqItem",
  "faqItemOpen": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqItemOpen",
  "faqQue": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqQue",
  "faqQues": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqQues",
  "faqQuesHeading": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqQuesHeading",
  "faqTabFadeIn": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqTabFadeIn",
  "faqblock": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqblock",
  "faqtab": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqtab",
  "faqtabQes": "FaqWithoutCategory-module-scss-module__HQ-QOa__faqtabQes",
  "homeHeadingFaq": "FaqWithoutCategory-module-scss-module__HQ-QOa__homeHeadingFaq",
  "icon": "FaqWithoutCategory-module-scss-module__HQ-QOa__icon",
  "jobRoleAns": "FaqWithoutCategory-module-scss-module__HQ-QOa__jobRoleAns",
  "jobRoleBlock": "FaqWithoutCategory-module-scss-module__HQ-QOa__jobRoleBlock",
  "jobRoleHeading": "FaqWithoutCategory-module-scss-module__HQ-QOa__jobRoleHeading",
  "jobRoleQue": "FaqWithoutCategory-module-scss-module__HQ-QOa__jobRoleQue",
  "leadTheFutureContainerInner": "FaqWithoutCategory-module-scss-module__HQ-QOa__leadTheFutureContainerInner",
  "mainHeadingFaq": "FaqWithoutCategory-module-scss-module__HQ-QOa__mainHeadingFaq",
  "tabBtnFaq": "FaqWithoutCategory-module-scss-module__HQ-QOa__tabBtnFaq",
  "tabPanel": "FaqWithoutCategory-module-scss-module__HQ-QOa__tabPanel",
});
